module.exports = __webpack_public_path__ + "img/fondo-mov.253f1726.png";